import Group from "./Group";
import Item from "./Item";

const Checkbox = {
  Item,
  Group,
};

export default Checkbox;
